import { createSelector } from 'reselect';
import { Contest, Nullable } from '@Models';
import { AppState } from '@Redux/store';
import { MyContestState } from '@Stores/index';
import { ContestView } from './view/ContestView';

const getContestState = (state: AppState): MyContestState => state.myContest;

const getMyContest = (state: AppState): Nullable<Contest> =>
  state.myContest.entity;

export const myContestPresenter = createSelector(
  [getContestState, getMyContest],
  (myContestSate, myContest): ContestView => {
    return new ContestView({
      id: myContestSate.id ?? '',
      name: myContest?.name ?? '',
    });
  },
);
